import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { environment } from 'src/environments/environment';
import { ContractService } from 'src/app/services/http/business/contract/contract.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import * as moment from "jalali-moment";
import { IError } from 'src/app/interfaces/error.interface';


@Component({
  selector: 'app-contract-extension',
  templateUrl: './contract-extension.component.html',
  styleUrls: ['./contract-extension.component.css']
})
export class ContractExtensionComponent implements OnInit {

  now = new Date();
  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  minDate: any;

  constructor(
    private fb: FormBuilder,
    private contractService: ContractService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ContractExtensionComponent>
  ) { }

  ngOnInit() {
    this.createForm();
    // this.setMindate();
  }
  createForm() {
    var start = new Date(new Date(this.data.ContractEndDate).setDate(new Date(this.data.ContractEndDate).getDate() + 1));
    var end = new Date(new Date(this.data.ContractEndDate).setDate(new Date(this.data.ContractEndDate).getDate() + 365));
    this.form = this.fb.group({
      ParentId: [this.data.Id],
      ContractStartDate: [start, Validators.compose([Validators.required])],
      ContractEndDate: [end, Validators.compose([Validators.required])],
      ContractNumber: [null, Validators.compose([Validators.required])],
      RoleName: [this.data.RoleName],
      ContractTypeName: [this.data.ContractTypeName],
      ActivateCode: [this.data.ActivateCode]
    });
    this.form.controls["ContractNumber"].patchValue(parseInt(this.data.ContractNumber))
  }

  // setMindate() {
  //   this.settingService.getContractDate().subscribe(
  //     res => {
  //       this.minDate = moment.from(res.Date.toString(), "en");
  //     },
  //     () => {
  //       this.errorService.transactionError();
  //     }
  //   );
  // }

  onNoClick() {
    this.dialogRef.close();
  }
  getParsDate(date: any): number {
    if (typeof (date) === 'string')
      return Date.parse(date);
    else if (date instanceof Date)
      return new Date(date).getTime()
  }
  submit(data: any) {
    this.form.value.ContractStartDate = moment
      .from(data.ContractStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.form.value.ContractEndDate = moment
      .from(data.ContractEndDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    this.contractService.getListLastContractSave([this.form.value]).subscribe(() => {
      this.snackBar.OpenSnackBar(
        'تمدید قرارداد با موفقیت انجام شد',
        "ok",
        5000,
        SoundEnum.beep
      );
      this.onNoClick();
    },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      })
  }
}
